var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurgeon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 71,
    viewBox: "0 0 50 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.558 50.5H12.8592C11.2374 50.5 9.63153 50.8194 8.13322 51.4401C6.63491 52.0607 5.27352 52.9703 4.12677 54.1171C2.98002 55.2639 2.07037 56.6253 1.44976 58.1236C0.829156 59.6219 0.509745 61.2278 0.509766 62.8496C0.509766 65.5776 1.06027 66.8553 5.44956 67.7893C5.44956 67.7893 20.2264 70.3889 25.2087 70.3889C30.1911 70.3889 44.9679 67.7895 44.9679 67.7895C49.3572 66.8553 49.9077 65.5776 49.9077 62.8496C49.9077 59.5743 48.6066 56.4332 46.2906 54.1172C43.9747 51.8013 40.8335 50.5002 37.5583 50.5002L37.558 50.5Z",
    fill: "#E9E9FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2084 57.9099C23.2433 57.9099 21.3586 57.1293 19.9691 55.7397C18.5795 54.3501 17.7988 52.4655 17.7988 50.5003V45.5605H32.618V50.5003C32.618 52.4655 31.8374 54.3501 30.4478 55.7397C29.0582 57.1293 27.1736 57.9099 25.2084 57.9099Z",
    fill: "#F2A783"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2084 57.9099C23.2433 57.9099 21.3586 57.1293 19.9691 55.7397C18.5795 54.3501 17.7988 52.4655 17.7988 50.5003V45.5605H32.618V50.5003C32.618 52.4655 31.8374 54.3501 30.4478 55.7397C29.0582 57.1293 27.1736 57.9099 25.2084 57.9099Z",
    fill: "url(#paint0_linear_2687_2257)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3037 34.6479C42.3466 34.3924 42.4682 34.1566 42.6515 33.9734C42.8347 33.7902 43.0706 33.6687 43.3262 33.6259C44.4707 33.4225 45.5082 32.8254 46.259 31.9378C47.0098 31.0503 47.4267 29.9282 47.4376 28.7658V25.0609C47.4265 23.8935 47.006 22.767 46.2494 21.8779C45.4927 20.9888 44.448 20.3935 43.2974 20.1958C43.0505 20.1536 42.8219 20.0388 42.6406 19.8659C42.4594 19.693 42.3339 19.47 42.2801 19.2254C41.7887 17.0287 40.5643 15.0647 38.8083 13.6563C37.0523 12.248 34.8692 11.4793 32.6182 11.4766H17.7989C15.5479 11.4793 13.3648 12.248 11.6088 13.6563C9.85278 15.0647 8.62837 17.0287 8.13697 19.2254C8.08322 19.47 7.95772 19.693 7.77653 19.8659C7.59533 20.0387 7.36668 20.1536 7.11983 20.1958C5.96919 20.3934 4.92444 20.9888 4.16779 21.8779C3.41114 22.767 2.99059 23.8935 2.97949 25.0609V28.7658C2.99035 29.9282 3.40724 31.0503 4.15802 31.9378C4.9088 32.8253 5.94622 33.4225 7.09078 33.6259C7.34634 33.6687 7.58219 33.7902 7.76547 33.9734C7.94874 34.1566 8.07032 34.3924 8.11326 34.6479H42.3037Z",
    fill: "#F2A783"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3037 34.6479C42.3466 34.3924 42.4682 34.1566 42.6515 33.9734C42.8347 33.7902 43.0706 33.6687 43.3262 33.6259C44.4707 33.4225 45.5082 32.8254 46.259 31.9378C47.0098 31.0503 47.4267 29.9282 47.4376 28.7658V25.0609C47.4265 23.8935 47.006 22.767 46.2494 21.8779C45.4927 20.9888 44.448 20.3935 43.2974 20.1958C43.0505 20.1536 42.8219 20.0388 42.6406 19.8659C42.4594 19.693 42.3339 19.47 42.2801 19.2254C41.7887 17.0287 40.5643 15.0647 38.8083 13.6563C37.0523 12.248 34.8692 11.4793 32.6182 11.4766H17.7989C15.5479 11.4793 13.3648 12.248 11.6088 13.6563C9.85278 15.0647 8.62837 17.0287 8.13697 19.2254C8.08322 19.47 7.95772 19.693 7.77653 19.8659C7.59533 20.0387 7.36668 20.1536 7.11983 20.1958C5.96919 20.3934 4.92444 20.9888 4.16779 21.8779C3.41114 22.767 2.99059 23.8935 2.97949 25.0609V28.7658C2.99035 29.9282 3.40724 31.0503 4.15802 31.9378C4.9088 32.8253 5.94622 33.4225 7.09078 33.6259C7.34634 33.6687 7.58219 33.7902 7.76547 33.9734C7.94874 34.1566 8.07032 34.3924 8.11326 34.6479H42.3037Z",
    fill: "url(#paint1_radial_2687_2257)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15338 34.2647L6.8012 20.1463C6.63048 19.1217 8.17943 18.8626 8.35047 19.8882L10.7027 34.0066L9.15338 34.2647Z",
    fill: "#EDDFF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3542 27.4936C20.315 26.5328 20.315 24.975 19.3542 24.0143C18.3934 23.0535 16.8357 23.0535 15.8749 24.0143C14.9141 24.975 14.9141 26.5328 15.8749 27.4936C16.8357 28.4543 18.3934 28.4543 19.3542 27.4936Z",
    fill: "#3D3C3B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5437 27.4936C35.5044 26.5328 35.5044 24.975 34.5437 24.0143C33.5829 23.0535 32.0251 23.0535 31.0644 24.0143C30.1036 24.975 30.1036 26.5328 31.0644 27.4936C32.0251 28.4543 33.5829 28.4543 34.5437 27.4936Z",
    fill: "#3D3C3B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.841 33.8675H35.6597C33.0063 33.8675 30.4562 33.001 28.2292 31.5585C27.2559 30.928 24.738 29.9038 22.1832 31.5585C19.9561 33.001 17.4062 33.8673 14.7527 33.8673H7.57715C7.71536 34.7103 9.33531 49.8088 25.2076 49.8088C38.1716 49.8088 41.8133 40.1701 42.841 33.8675Z",
    fill: "#EAF5FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7153 34.0061L42.0677 19.8879C42.2386 18.863 43.7875 19.1214 43.6169 20.1461L41.2648 34.2643L39.7153 34.0061Z",
    fill: "#E5C2FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.841 33.8675H35.6597C33.0063 33.8675 30.4562 33.001 28.2292 31.5585C27.2559 30.928 24.738 29.9038 22.1832 31.5585C19.9561 33.001 17.4062 33.8673 14.7527 33.8673H7.57715C7.71536 34.7103 9.33531 49.8088 25.2076 49.8088C38.1716 49.8088 41.8133 40.1701 42.841 33.8675Z",
    fill: "url(#paint2_radial_2687_2257)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.216 1.58187C32.401 -0.102473 20.6161 -0.855748 12.201 1.58187C9.53885 2.35712 7.20041 3.97581 5.53741 6.19445C3.87441 8.4131 2.97676 11.1117 2.9795 13.8845V26.7511C13.041 11.2865 37.3787 11.2904 47.4376 26.7511V13.8845C47.4403 11.1117 46.5427 8.41307 44.8796 6.19442C43.2166 3.97576 40.8781 2.35709 38.216 1.58187Z",
    fill: "#4B4AD5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.216 1.58187C32.401 -0.102473 20.6161 -0.855748 12.201 1.58187C9.53885 2.35712 7.20041 3.97581 5.53741 6.19445C3.87441 8.4131 2.97676 11.1117 2.9795 13.8845V26.7511C13.041 11.2865 37.3787 11.2904 47.4376 26.7511V13.8845C47.4403 11.1117 46.5427 8.41307 44.8796 6.19442C43.2166 3.97576 40.8781 2.35709 38.216 1.58187Z",
    fill: "url(#paint3_linear_2687_2257)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8839 50.7228C36.2155 55.1457 30.9985 57.9106 25.2087 57.9106C19.4189 57.9106 14.2017 55.1459 10.5335 50.7227C7.71345 51.2637 5.17002 52.7705 3.34064 54.9839C1.51125 57.1973 0.510251 59.9789 0.509766 62.8504C0.509766 65.5785 1.06027 66.8562 5.4494 67.7902C5.4494 67.7902 20.2264 70.3898 25.2087 70.3898C30.1911 70.3898 44.9679 67.7902 44.9679 67.7902C49.3572 66.8562 49.9075 65.5785 49.9075 62.8504C49.907 59.979 48.906 57.1974 47.0767 54.9841C45.2473 52.7707 42.7039 51.2639 39.8839 50.7228Z",
    fill: "#4B4AD5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8839 50.7228C36.2155 55.1457 30.9985 57.9106 25.2087 57.9106C19.4189 57.9106 14.2017 55.1459 10.5335 50.7227C7.71345 51.2637 5.17002 52.7705 3.34064 54.9839C1.51125 57.1973 0.510251 59.9789 0.509766 62.8504C0.509766 65.5785 1.06027 66.8562 5.4494 67.7902C5.4494 67.7902 20.2264 70.3898 25.2087 70.3898C30.1911 70.3898 44.9679 67.7902 44.9679 67.7902C49.3572 66.8562 49.9075 65.5785 49.9075 62.8504C49.907 59.979 48.906 57.1974 47.0767 54.9841C45.2473 52.7707 42.7039 51.2639 39.8839 50.7228Z",
    fill: "url(#paint4_linear_2687_2257)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3542 27.4936C20.315 26.5328 20.315 24.975 19.3542 24.0143C18.3934 23.0535 16.8357 23.0535 15.8749 24.0143C14.9141 24.975 14.9141 26.5328 15.8749 27.4936C16.8357 28.4543 18.3934 28.4543 19.3542 27.4936Z",
    fill: "url(#paint5_radial_2687_2257)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5437 27.4936C35.5044 26.5328 35.5044 24.975 34.5437 24.0143C33.5829 23.0535 32.0251 23.0535 31.0644 24.0143C30.1036 24.975 30.1036 26.5328 31.0644 27.4936C32.0251 28.4543 33.5829 28.4543 34.5437 27.4936Z",
    fill: "url(#paint6_radial_2687_2257)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2687_2257",
    x1: 25.2084,
    y1: 57.9099,
    x2: 25.2084,
    y2: 45.5605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A783",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#F0A17F",
    stopOpacity: 0.123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#ED9777",
    stopOpacity: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#EA8E71",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E7876B",
    stopOpacity: 0.713
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "#E58167",
    stopOpacity: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#E47D64",
    stopOpacity: 0.928
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#E37B63",
    stopOpacity: 0.982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37A62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2687_2257",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.70773 10.9528) scale(38.5166 38.5166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A783",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#F2A682",
    stopOpacity: 0.017
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#F1A481",
    stopOpacity: 0.068
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#F0A07E",
    stopOpacity: 0.153
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#EE9B7A",
    stopOpacity: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#EC9475",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#E98B6F",
    stopOpacity: 0.618
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#E58167",
    stopOpacity: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37A62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2687_2257",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.00125 24.7143) scale(38.3931 38.3931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDFF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDDFF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2687_2257",
    x1: 2.9795,
    y1: 13.3872,
    x2: 47.4375,
    y2: 13.3872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A461D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#A461D8",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A461D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2687_2257",
    x1: 0.509766,
    y1: 60.5562,
    x2: 49.9077,
    y2: 60.5562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A461D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#A461D8",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A461D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2687_2257",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3231 22.5624) scale(5.43077 5.43077)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#3D3C3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#393837",
    stopOpacity: 0.169
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#2D2C2B",
    stopOpacity: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242423"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2687_2257",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5124 22.5624) scale(5.43077)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#3D3C3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#393837",
    stopOpacity: 0.169
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#2D2C2B",
    stopOpacity: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgeon);
export default __webpack_public_path__ + "static/media/surgeon.df3dcdff8d2b8965959be77fb88863b7.svg";
export { ForwardRef as ReactComponent };